import { fetchLayoutScreens, useGetLayoutScreens } from 'src/hooks';

export const useGetScreenSetup = (layoutId?: number) => {
  let screenSetup: string = '';
  const { data: layoutScreens } = useGetLayoutScreens(layoutId, !!layoutId);

  if (layoutScreens && layoutScreens.length > 0) {
    const { screens } = layoutScreens[0];
    const numberOfVerticalScreens = screens.filter(
      (screen) => screen.height > screen.width,
    ).length;
    const numberOfHorizontalScreens = screens.filter(
      (screen) => screen.width > screen.height,
    ).length;

    if (numberOfVerticalScreens > 0 && numberOfHorizontalScreens > 0) {
      numberOfVerticalScreens === 1 && numberOfHorizontalScreens === 1
        ? (screenSetup = `${numberOfVerticalScreens} vertical screen, ${numberOfHorizontalScreens} horizontal screen`)
        : (screenSetup = `${numberOfVerticalScreens} vertical screens, ${numberOfHorizontalScreens} horizontal screens`);
    } else if (numberOfVerticalScreens > 0) {
      numberOfVerticalScreens === 1
        ? (screenSetup = `${numberOfVerticalScreens} vertical screen`)
        : (screenSetup = `${numberOfVerticalScreens} vertical screens`);
    } else if (numberOfHorizontalScreens > 0) {
      numberOfHorizontalScreens === 1
        ? (screenSetup = `${numberOfHorizontalScreens} horizontal screen`)
        : (screenSetup = `${numberOfHorizontalScreens} horizontal screens`);
    }
  }

  return {
    screenSetup,
  };
};

export const getScreenSetup = async (layoutId?: number): Promise<string> => {
  if (!layoutId) return '';

  const layoutScreens = await fetchLayoutScreens(layoutId);

  if (!layoutScreens || layoutScreens.length === 0) return '';

  const screens = layoutScreens[0].screens;

  const numberOfVerticalScreens = screens.filter(
    (screen) => screen.height > screen.width,
  ).length;
  const numberOfHorizontalScreens = screens.filter(
    (screen) => screen.width > screen.height,
  ).length;

  const pluralize = (count: number, label: string) =>
    `${count} ${label}${count === 1 ? '' : 's'}`;

  if (numberOfVerticalScreens > 0 && numberOfHorizontalScreens > 0) {
    return `${pluralize(numberOfVerticalScreens, 'vertical screen')}, 
    ${pluralize(numberOfHorizontalScreens, 'horizontal screen')}`;
  } else if (numberOfVerticalScreens > 0) {
    return `${pluralize(numberOfVerticalScreens, 'vertical screen')}`;
  } else if (numberOfHorizontalScreens > 0) {
    return `${pluralize(numberOfHorizontalScreens, 'horizontal screen')}`;
  }

  return '';
};
